export interface Testimonial {
  initials: string
  name: string
  role: string
  text: string
}

export const stripTestimonials: Testimonial[] = [
  {
    initials: 'SM',
    name: 'S.M.',
    role: 'Drawing Teacher — London, UK',
    text: '"I used to spend every Sunday night writing lesson plans and constructing exercises. Now I open the library, choose a lesson, and walk in completely prepared. My students feel the difference—and so do I."',
  },
  {
    initials: 'RK',
    name: 'R.K.',
    role: 'Art Teacher — Toronto, Canada',
    text: '"The Exercise Drills library by themselves were worth the entire price. I teach mixed levels and I used to scramble finding quick activities. Now I have 150 ready-to-go exercises organized by skill."',
  },
  {
    initials: 'JP',
    name: 'J.P.',
    role: 'Drawing Instructor — Sydney, Australia',
    text: '"The Correction Library completely changed how I give feedback. My corrections are clearer, more specific, and my students actually understand what I\'m asking."',
  },
]

export const extendedTestimonials: Testimonial[] = [
  {
    initials: 'SM',
    name: 'S.M.',
    role: 'Drawing Teacher | London, UK',
    text: 'I used to spend every Sunday night writing lesson plans and constructing exercises. Now I open the library, choose a lesson, and walk in completely prepared. My students feel the difference—and so do I.',
  },
  {
    initials: 'RK',
    name: 'R.K.',
    role: 'Art Teacher | Toronto, Canada',
    text: 'The Exercise Drills library by themselves were worth the entire price. I teach mixed levels and I used to scramble finding quick activities. Now I have 150 ready-to-go exercises organized by skill.',
  },
  {
    initials: 'JP',
    name: 'J.P.',
    role: 'Drawing Instructor | Sydney, Australia',
    text: "The Correction Library completely changed how I give feedback. My corrections are clearer, more specific, and my students actually understand what I'm asking. The signals are professional and consistent.",
  },
  {
    initials: 'MT',
    name: 'M.T.',
    role: 'Art Educator | Barcelona, Spain',
    text: 'The Course Builder helped me structure my entire 12-week program. Before this, I was guessing at progression. Now everything connects logically and students can see how each skill builds on the previous one.',
  },
  {
    initials: 'DG',
    name: 'D.G.',
    role: 'Drawing Teacher | Auckland, New Zealand',
    text: "The Rescue Vault saved me countless times. When a lesson isn't working or time runs short, I have immediate alternatives that keep the class flowing. It's like having a mentor in your back pocket.",
  },
  {
    initials: 'CV',
    name: 'C.V.',
    role: 'Private Art Tutor | Vancouver, Canada',
    text: 'I teach private students and the mixed-level adaptations let me teach the same concept to foundation and advanced students in the same session. My confidence has never been higher.',
  },
]
